export default __webpack_public_path__ + "static/media/seja-nosso-parceiro.8a5bd88a.png";